import { Component, Injector, Optional, Input, ChangeDetectorRef } from '@angular/core';

import { InstrumentDefinitieService } from 'src/app/core/service/instrument-definitie.service';
import { InstrumentDefinitie } from 'src/app/core/dto/instrument-definitie';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType, TitleService } from '@mango/core';
import { Groep } from 'src/app/core/enums/groep';
import { startWith, takeUntil } from 'rxjs/operators';
import { ProjectregelService } from 'src/app/core/service/projectregel.service';

@Component({
    selector: 'c-i-j-borculo-instrument-definitie-collection',
    templateUrl: './instrument-definitie-collection.component.html'/*,
    styleUrls: ['./instrument-definitie-collection.component.css'] */
})
export class InstrumentDefinitieCollectionComponent extends PagedCollectionComponent<InstrumentDefinitie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<InstrumentDefinitie>([
		
		{ colDef: 'rubriek', prop: x => x.rubriekID.omschr, searchable: SearchableType.String },
		{ colDef: 'groep', prop: x => x.groep, searchable: { type: SearchableType.Enum, enum: Groep } },		
		{ colDef: 'soortID', prop: x => x.soortID.omschrijving, searchable: SearchableType.String },
		{ colDef: 'merkID', prop: x => x.merkID.omschrijving, searchable: SearchableType.String },
		{ colDef: 'type', prop: x => x.type, searchable: SearchableType.String },
		{ colDef: 'PrijsStd', prop: x => x.prijsStd, searchable: SearchableType.Number },		
		{ colDef: 'PrijsCY', prop: x => x.prijsCY, searchable: SearchableType.Number },		
		{ colDef: 'PrijsRvA', prop: x => x.prijsRvA, searchable: SearchableType.Number },		
		{ colDef: 'PrijsBRL100', prop: x => x.prijsBrl100, searchable: SearchableType.Number },		
		{ colDef: 'PrijsNen', prop: x => x.prijsNen, searchable: SearchableType.Number },		
		{ colDef: 'PrijsKeuring', prop: x => x.prijsKeuring, searchable: SearchableType.Number },		
		{ colDef: 'PrijsCrossCheck', prop: x => x.prijsCrossCheck, searchable: SearchableType.Number },		
		{ colDef: 'PrijsScios', prop: x => x.prijsScios, searchable: SearchableType.Number },		
		{ colDef: 'PrijsBRL6010', prop: x => x.prijsBRL6010, searchable: SearchableType.Number },
		{ colDef: 'PrijsPool', prop: x => x.prijsPool, searchable: SearchableType.Number },
		{ colDef: 'PrijsKwestie', prop: x => x.prijsKwestie, searchable: SearchableType.Number },
      	{ colDef: 'PrijsPoolBuiten', prop: x => x.prijsPoolBuiten, searchable: SearchableType.Number },
      	{ colDef: 'PrijsKwestieBuiten', prop: x => x.prijsKwestieBuiten, searchable: SearchableType.Number },

    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: InstrumentDefinitieService,
		@Optional() protected filter: Filter<InstrumentDefinitie>, injector: Injector, private titleService: TitleService, private projectregelService: ProjectregelService) {
        super('/instrumentDefinitie/instrumentDefinitie', injector, InstrumentDefinitie);

    }

	ngOnInit() {
        super.ngOnInit();

		this.filter.onUpdate.pipe(takeUntil(this.onDestroy$),startWith(this.filter)).subscribe(x => {
			let fp1 = this.filter.getProperties().filter(fp => fp.p == "groep")[0];
			let isMI = fp1 && fp1.v == '1';
			let isEN = fp1 && fp1.v == '2';

			// this.cdr.detectChanges();
			if (isMI) {
				setTimeout(()=>this.titleService.setCollectionTitle("Instrument Prijslijst MI"));
				
			} else if (isEN) {
				setTimeout(()=>this.titleService.setCollectionTitle("Instrument Contract EN"));
			}
		});

		this.buildCustomActions(config => config.add({
			icon: 'download',
			name: "",
			pin: true,
			show: () => this.authScheme.canDo("CIJBorculo.Logic.InstrumentDefinitieExportRequest"),
			fn: () => this.DownloadExcel()
	  	}));

		this.filter.onGetChipLabel(x => x.groep, () => 'Groep');
		this.filter.onGetChipLabel(x => x.soortID.omschrijving, () => 'Soort');
		this.filter.onGetChipLabel(x => x.merkID.omschrijving, () => 'Merk');
		this.filter.onGetChipLabel(x => x.type, () => 'Type');
		this.filter.onGetChipLabel(x => x.rubriekID.omschr, () => 'Rubriek');

		this.filter.onGetChipLabel(x => x.prijsStd, () => 'Prijs Std');
		this.filter.onGetChipLabel(x => x.prijsCY, () => 'Prijs CIJ');
		this.filter.onGetChipLabel(x => x.prijsRvA, () => 'Prijs RvA');
		this.filter.onGetChipLabel(x => x.prijsBrl100, () => 'Prijs BRL100');
		this.filter.onGetChipLabel(x => x.prijsNen, () => 'Prijs NEN');
		this.filter.onGetChipLabel(x => x.prijsKeuring, () => 'Prijs Keuring');
		this.filter.onGetChipLabel(x => x.prijsCrossCheck, () => 'Prijs CrossCheck');
		this.filter.onGetChipLabel(x => x.prijsScios, () => 'Prijs Scios');
		this.filter.onGetChipLabel(x => x.prijsBRL6010, () => 'Prijs BRL6010');
		this.filter.onGetChipLabel(x => x.prijsPool, () => 'Prijs Pool Binnen');
		this.filter.onGetChipLabel(x => x.prijsPoolBuiten, () => 'Prijs Pool Buiten');
		this.filter.onGetChipLabel(x => x.prijsKwestie, () => 'Prijs Kwestie Binnen');
		this.filter.onGetChipLabel(x => x.prijsKwestieBuiten, () => 'Prijs Kwestie Buiten');

    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		return super.displayColumn(colDef, ix);
	}

	getGroep(value) {

		switch (Number(value)) {
			case Groep.MeetInstrument:
				return "MI";
			case Groep.Energie:
				return "EN";
			default:
				return value;
		}
	}

	
	DownloadExcel() {
		this.service.downloadExcelFile(this.filter).toPromise().then(
			(value) => {
				if (value.successful) {
						var blob = this.projectregelService.ConvertResponseToBlob(value);
						var url = window.URL.createObjectURL(blob);
						let anchor = document.createElement('a');
						anchor.href = url;
						
						if (value.fileName) {
							anchor.setAttribute('download', value.fileName);
						}
						anchor.target = '_blank';
						anchor.click();
					}
					else {
						this.dialogs.snackAction("Het document is niet gevonden!", ()=>{},"ok", 3000);
					}
			});
	}
}
